export class FoodTypeRequest{
    foodTypeId : number;
    
    constructor(foodTypeId : number)
    {
        this.foodTypeId = foodTypeId;
        
    }
}
